import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { userMenuTranslationRef } from './userMenu';

export const userMenuTranslations = createTranslationResource({
  ref: userMenuTranslationRef,
  translations: {
    'pt-BR': () => import('./userMenu-pt-BR'),
  },
});

export { userMenuTranslationRef } from './userMenu';

